import { ScoreBucketRange } from "@/modules/types/dashboard";

export const chartColors = {
  primary: "var(--color-primary, var(--primary))",
  secondary: "var(--color-secondary, var(--secondary))",
  hot: "var(--color-hot, #f97316)",
  success: "var(--color-success, #16a34a)",
  danger: "var(--color-danger, #dc2626)",
  slate: "#64748b",
  amber: "#f59e0b",
  purple: "#8b5cf6",
  blue: "#3b82f6",
} as const;

export const bucketStartMap: Record<ScoreBucketRange, number> = {
  "0-20": 0,
  "21-40": 21,
  "41-60": 41,
  "61-80": 61,
  "81-100": 81,
};

export const emptyPipeline = {
  new: 0,
  reviewing: 0,
  processing: 0,
  discarded: 0,
  hired: 0,
};

export const cardClassName =
  "rounded-2xl border border-slate-200/70 bg-[var(--color-bg-card,#ffffff)] p-4 shadow-sm dark:border-gray-700/80 dark:bg-gray-900 md:p-5";

export const panelTitleClassName =
  "text-sm font-semibold text-slate-800 dark:text-slate-100";

export const panelSubtleClassName =
  "text-xs text-slate-500 dark:text-slate-400";
